var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMessage = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.913635 3.66647C0.913635 2.64967 1.73323 1.83008 2.75002 1.83008H21.7163L19.2531 6.65912V18.3331C19.2531 19.3499 18.4335 20.1695 17.4167 20.1695H2.75002C1.73323 20.1695 0.913635 19.3499 0.913635 18.3331V3.66647ZM2.75002 2.75286C2.24286 2.75286 1.83641 3.15931 1.83641 3.66647V18.3331C1.83641 18.8403 2.24286 19.2467 2.75002 19.2467H17.4167C17.9239 19.2467 18.3303 18.8403 18.3303 18.3331V6.43736L20.2097 2.75286H2.75002Z",
    fill: "#B41730"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 13.7529H3.66669V12.8301H16.5V13.7529Z",
    fill: "#B41730"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 9.16887H3.66669V8.24609H16.5V9.16887Z",
    fill: "#B41730"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMessage);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/message.dc4b437ec49a296668e6fe06f72612b7.svg";